import { render, staticRenderFns } from "./addInvoice.vue?vue&type=template&id=3ecdbc2c"
import script from "./addInvoice.vue?vue&type=script&lang=js"
export * from "./addInvoice.vue?vue&type=script&lang=js"
import style0 from "./addInvoice.vue?vue&type=style&index=0&id=3ecdbc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports